// ArChat apiReviews
// Created: 22-04-2026 19:30:00
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * @file api/apiReviews.js
 * @description Métodos API para el módulo ArChat Reviews MVP.
 * Se integra con apiService vía Object.assign en services/api.js.
 * @author SIVOL Technologies
 * @version 1.0.0
 */

const REVIEWS_BASE = '/api/reviews.php';

export const apiReviewsMethods = {
  /**
   * @returns {Promise<{success: boolean, has_review: boolean, review: object|null}>}
   */
  async getMyReview() {
    return this.request(`${REVIEWS_BASE}?action=my-review`, { method: 'GET', _skipGlobalErrorModal: true });
  },

  /**
   * @param {number} rating 1-5
   * @param {string} [comment]
   * @returns {Promise<{success: boolean, review: object}>}
   */
  async submitReview(rating, comment = '') {
    return this.request(`${REVIEWS_BASE}?action=my-review`, {
      method: 'POST',
      body: JSON.stringify({ rating, comment }),
      _skipGlobalErrorModal: true,
    });
  },

  /**
   * Editar reseña existente (PUT).
   * @param {number} rating 1-5
   * @param {string} [comment]
   * @returns {Promise<{success: boolean, review: object}>}
   */
  async updateReview(rating, comment = '') {
    return this.request(`${REVIEWS_BASE}?action=my-review`, {
      method: 'PUT',
      body: JSON.stringify({ rating, comment }),
      _skipGlobalErrorModal: true,
    });
  },

  /**
   * @param {number} [limit=50]
   * @param {number} [offset=0]
   * @returns {Promise<{success: boolean, reviews: Array}>}
   */
  async getPublicReviews(limit = 50, offset = 0) {
    return this.request(`${REVIEWS_BASE}?action=public&limit=${limit}&offset=${offset}`, {
      method: 'GET',
      _skipGlobalErrorModal: true,
    });
  },

  /**
   * @returns {Promise<{success: boolean, total: number, average: number, distribution: object}>}
   */
  async getReviewsSummary() {
    return this.request(`${REVIEWS_BASE}?action=summary`, { method: 'GET', _skipGlobalErrorModal: true });
  },

  /**
   * @param {number} [sessionCount=0]
   * @returns {Promise<{success: boolean, should_show: boolean, reason: string}>}
   */
  async checkReviewPrompt(sessionCount = 0) {
    return this.request(`${REVIEWS_BASE}?action=prompt-check&session_count=${sessionCount}`, {
      method: 'GET',
      _skipGlobalErrorModal: true,
    });
  },

  /** @returns {Promise<{success: boolean}>} */
  async recordPromptShown() {
    return this.request(`${REVIEWS_BASE}?action=prompt-shown`, { method: 'POST', _skipGlobalErrorModal: true });
  },

  /** @returns {Promise<{success: boolean}>} */
  async recordPromptDismiss() {
    return this.request(`${REVIEWS_BASE}?action=prompt-dismiss`, { method: 'POST', _skipGlobalErrorModal: true });
  },

  /**
   * @param {number} [hours=72]
   * @returns {Promise<{success: boolean}>}
   */
  async snoozePrompt(hours = 72) {
    return this.request(`${REVIEWS_BASE}?action=prompt-snooze`, {
      method: 'POST',
      body: JSON.stringify({ hours }),
      _skipGlobalErrorModal: true,
    });
  },
};
